import { ApolloQueryResult } from '@apollo/client';
import apolloClient from 'api/apolloClient';
import {
  DOMAIN_V2_BY_ID_FROM_COOKIES,
  DOMAIN_V2_CONFIG_BY_DATE,
  DOMAIN_V2_PRODUCT_LINES,
  DOMAIN_V2_PRODUCT_LINES_BY_EFFECTIVE_DATE_AND_STATE,
  GET_ALL_DOMAINS,
} from 'api/queries/domainServiceV2';
import { InputFilter, DomainProductLine, Config, Domain } from 'types/domainServiceV2';

export async function getDomainProductLine(inputFilter: InputFilter): Promise<DomainProductLine[]> {
  return (
    await apolloClient.query<{ getProductLines: DomainProductLine[] }>({
      query: DOMAIN_V2_PRODUCT_LINES,
      variables: {
        inputFilter,
      },
    })
  ).data.getProductLines;
}

export async function getProductLinesByEffectiveDateAndState(
  id: string,
  effectiveDate: string,
  state: string,
): Promise<DomainProductLine[]> {
  return (
    await apolloClient.query<{ getProductLinesByEffectiveDateAndState: DomainProductLine[] }>({
      query: DOMAIN_V2_PRODUCT_LINES_BY_EFFECTIVE_DATE_AND_STATE,
      variables: {
        id,
        effectiveDate,
        state,
      },
    })
  ).data.getProductLinesByEffectiveDateAndState;
}

export async function getConfigByDate(id: string, effectiveDate: string): Promise<Config> {
  return (
    await apolloClient.query<{ getConfigByEffectiveDate: Config }>({
      query: DOMAIN_V2_CONFIG_BY_DATE,
      variables: {
        id,
        effectiveDate,
      },
    })
  ).data.getConfigByEffectiveDate;
}

export async function getDomainByIdFromCookies(): Promise<Domain> {
  return (
    await apolloClient.query<{ getDomainByIdFromCookies: Domain }>({
      query: DOMAIN_V2_BY_ID_FROM_COOKIES,
    })
  ).data.getDomainByIdFromCookies;
}

export async function getAllDomains(): Promise<ApolloQueryResult<{ getAllDomains: Domain[] }>> {
  return apolloClient.query<{ getAllDomains: Domain[] }>({
    query: GET_ALL_DOMAINS,
  });
}
